import {
  MAP_LOADED,
} from '../actions/Map.js';
import { store } from '../app.js';

window.initMap = function initMap() {
  store.dispatch({
    type: MAP_LOADED,
  });
};

export default (state = {
  isLoaded: false,
}, action) => {
  switch (action.type) {
    case MAP_LOADED:
      return Object.assign({}, state, {
        isLoaded: true,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Map.js